import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  SmartActionForecast,
  SmartActionsGuard,
} from "@/features/office/smart-actions";
import { smartActionBoardSearchSchema } from "@/features/office/smart-actions/_configs/board-search-schema";
import { filterSearchFragment } from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * The forecast filters by the board's Owner, Manager, Program and Value, so it
 * reads those keys exactly as the board's URL does (plus the notification
 * inbox's keys, which every office route's `filters` must accept).
 */
const forecastFiltersSchema = smartActionBoardSearchSchema.shape.filters
  .unwrap()
  .pick({
    ownerUserIds: true,
    managerUserIds: true,
    program: true,
    valueCents: true,
    unread: true,
    category: true,
    archived: true,
  });

const forecastSearchSchema = z.object({
  filters: forecastFiltersSchema.optional(),
  ...filterSearchFragment,
  /** What the bars stack by: "program", else the value tiers. Narrowed in the feature. */
  stack: z.string().optional().catch(undefined),
  ...maskSearchFragment,
});

export const routeId = "/office/smart-actions/forecast";

export const Route = createFileRoute("/office/smart-actions/forecast")({
  validateSearch: forecastSearchSchema,
  component: SmartActionForecastRoute,
});

/** Behind the same gate and role as the board, deep link included. */
function SmartActionForecastRoute() {
  return (
    <SmartActionsGuard>
      <SmartActionForecast />
    </SmartActionsGuard>
  );
}
